import { SupabaseMentor, SupabaseUser, UserResource } from "@vincer/types";

import { BaseApi } from "./baseApi";
import { supabase } from "./supabase";

type MenteeData = {
  uuid?: string;
  resources?: UserResource[];
  key_insights?: string[];
};

class UserApi extends BaseApi<SupabaseUser> {
  async getById(id: string): Promise<SupabaseUser | null> {
    const { data, error } = await supabase
      .from("vincer_base_user")
      .select(
        `
        uuid,
        name,
        email,
        date_joined,
        user_roles:user_roles (
          role_name
        ),
        mentee:mentee (
          uuid,
          resources,
          key_insights
        )
      `
      )
      .eq("uuid", id)
      .maybeSingle();
    if (error) throw error;
    if (!data) return null;

    // Map user_roles to roles array
    const roles = Array.isArray(data.user_roles)
      ? data.user_roles.map((r: { role_name: string }) => r.role_name)
      : [];

    const mentee = data.mentee as MenteeData | MenteeData[] | null | undefined;
    const menteeObj = Array.isArray(mentee) ? mentee[0] : mentee;

    return {
      uuid: data.uuid,
      name: data.name,
      email: data.email,
      dateJoined: data.date_joined,
      isMentee: roles.includes("MENTEE"),
      isMentor: roles.includes("MENTOR"),
      isAdmin: roles.includes("ADMIN"),
      roles,
      menteeUuid: menteeObj?.uuid ?? null,
      resources: menteeObj?.resources ?? [],
      keyInsights: menteeObj?.key_insights ?? [],
    };
  }
  async getMentorRecord(userUuid: string): Promise<SupabaseMentor | null> {
    const { data, error } = await supabase
      .from("mentor")
      .select(
        `
        uuid, 
        user_uuid, 
        specialization, 
        meetings_held, 
        google_calendar_token,
        vincer_base_user (
          uuid,
          name,
          email,
          date_joined
        )
      `
      )
      .eq("user_uuid", userUuid)
      .maybeSingle();
    if (error) throw error;
    if (!data) return null;
    return {
      uuid: data.uuid,
      userUuid: data.user_uuid,
      specialization: data.specialization,
      meetingsHeld: data.meetings_held,
      googleCalendarToken: data.google_calendar_token,
      user: data.vincer_base_user,
    };
  }
}

export const userApi = new UserApi("vincer_base_user");
